var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "GmapMap",
        {
          ref: "gmap",
          staticClass: "gmap",
          attrs: {
            center: _vm.mapCenter,
            zoom: _vm.mapZoom,
            "map-type-id": _vm.mapType,
            options: _vm.mapOptions
          }
        },
        [
          _c(
            "GmapCluster",
            {
              ref: "cluster",
              attrs: {
                styles: _vm.clusterStyles,
                "zoom-on-click": true,
                "grid-size": 20
              }
            },
            _vm._l(_vm.mapMarkers, function(m, index) {
              return _c(
                "GmapMarker",
                {
                  key: index,
                  attrs: {
                    position: m.position,
                    icon: m.icon,
                    clickable: true,
                    draggable: false,
                    title: m.title
                  },
                  on: {
                    click: function($event) {
                      return _vm.markerClicked(index)
                    }
                  }
                },
                [
                  _c(
                    "gmap-info-window",
                    {
                      staticClass: "info-window",
                      attrs: {
                        opened: _vm.infoWindow === "info-window-" + index
                      },
                      on: {
                        closeclick: function($event) {
                          _vm.infoWindow = ""
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "flex flex-col" }, [
                        _c("div", { staticClass: "text-xl" }, [
                          _vm._v(_vm._s(m.title))
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "my-1",
                          domProps: { innerHTML: _vm._s(m.address) }
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "link self-start mt-2 font-semibold",
                            attrs: { href: m.url }
                          },
                          [_vm._v("Meer info")]
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }